import { scroller } from 'react-scroll';

export const handleNavClick = (id, event) => {
  event.preventDefault(); // prevent the default link/button behavior
  scroller.scrollTo(id, {
    duration: 500,
    smooth: 'smooth',
    offset: -100,
    spy: true,
    hashSpy: true,
    updateUrl: true,
  });
};

export function hexToRgb(hex) {
  const r = parseInt(hex.substring(1, 3), 16);
  const g = parseInt(hex.substring(3, 5), 16);
  const b = parseInt(hex.substring(5, 7), 16);
  return `${r}, ${g}, ${b}`;
}

